import type { MasonryItemDimension } from './Masonry';

type ComputeMasonryProps = {
  itemsHeights: number[];
  columnsCount: number;
  columnsWidth: number;
  gap: [number, number];
  indent?: number;
};

export function computeMasonry({
  itemsHeights,
  columnsCount,
  columnsWidth,
  gap,
  indent = 0
}: ComputeMasonryProps) {
  if (itemsHeights.length === 0 || columnsCount === 0 || columnsWidth === 0) {
    return [[], 0] as [MasonryItemDimension[], number];
  }

  const columnsHeights = Array.from({ length: columnsCount }, () => 0);

  const itemsDimensions = itemsHeights.map((height) => {
    const withHeight = !!height;

    const shortestColumnIndex = columnsHeights.indexOf(
      Math.min(...columnsHeights)
    );

    const columnWidthWithGap = columnsWidth + gap[0];
    const x = withHeight
      ? indent + columnWidthWithGap * shortestColumnIndex
      : 0;

    const verticalGap = withHeight ? gap[1] : 0;
    const columnBaseHeight = columnsHeights[shortestColumnIndex];
    const y = columnBaseHeight ? columnBaseHeight + verticalGap : 0;

    columnsHeights[shortestColumnIndex] = y + height;

    return {
      x,
      y: withHeight ? y : 0,
      height,
      width: columnsWidth
    } as MasonryItemDimension;
  });

  return [itemsDimensions, Math.max(...columnsHeights)] as [
    MasonryItemDimension[],
    number
  ];
}
